export default __webpack_public_path__ + "static/media/icons.1b0f6ac7.svg";